var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.052 18.7099L33.5194 16.1993C33.0899 15.7734 32.3554 16.0754 32.3554 16.6775V18.6563H21.1983C17.7807 18.6563 15 21.437 15 24.8549V27.5113H16.0626V24.8549C16.0626 22.0228 18.3665 19.7189 21.1983 19.7189H32.3554V21.6983C32.3554 22.3006 33.0899 22.6018 33.5194 22.1762L36.052 19.6659C36.3182 19.4021 36.3182 18.9739 36.052 18.7101V18.7099Z",
    fill: "#F87E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1893 22.9072V25.5637C35.1893 28.3958 32.8854 30.6997 30.0536 30.6997H18.8965V28.7203C18.8965 28.1179 18.162 27.8168 17.7325 28.2427L15.2 30.753C14.9337 31.0171 14.9337 31.4449 15.2 31.7087L17.7325 34.2193C18.162 34.6452 18.8965 34.3435 18.8965 33.7411V31.7623H30.0536C33.4712 31.7623 36.2519 28.9816 36.2519 25.5637V22.9072H35.1893Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    stroke: "#F87E03",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.79d756c481086fa8b4ec0128f30649ed.svg";
export { ForwardRef as ReactComponent };